export function getGreeting() {
  const hr = new Date().getHours();
  if (hr < 12) {
    return 'Good Morning, my name is Robert Truese';
  } else if (hr < 18) {
    return 'Good Afternoon, my name is Robert Truese';
  } else {
    return 'Good Evening, my name is Robert Truese';
  }
}
